<template>
	<div class="basis-cls">
		<el-form :model="resourceForm" ref="resourceForm" autoComplete="on" label-width="80px" label-position="right">
			<el-form-item prop="name" label="名称：" :rules="[
				{required: true, trigger: 'blur', message: '请输入'}
			]">
				<el-input v-model="resourceForm.name" maxlength="20" show-word-limit placeholder="请输入" size="small" clearable></el-input>
			</el-form-item>
			<el-form-item prop="type" label="库类型：" :required="true">
				<el-tag :type="resourceForm.type == '2' ? '' : 'warning'" size="small">{{ resourceForm.type == '2' ? '流程' : '知识' }}</el-tag>
			</el-form-item>
			<el-form-item prop="remark" label="简介：">
				<el-input v-model="resourceForm.remark" type="textarea" :rows="4" maxlength="50" show-word-limit placeholder="请输入" size="small" clearable></el-input>
			</el-form-item>
			<el-form-item>
				<el-button :loading="loading" type="primary" @click="onSubmit" size="small">保 存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: ['row'],
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	watch: {
		row: {
			handler(val) {
				this.resourceForm = Object.assign(this.resourceForm, {
					name: val.name,
					type: val.type,
					remark: val.remark,
					id: val.id
				});
			},
			immediate:true,
			deep: true
		},
	},
	data() {
		return {
			loading: false,
			resourceForm: {
				projectId: '',
				name: '',
				type: '',
				remark: ''
			}
		}
	},
	methods: {
		onSubmit() {
			this.loading = true;
			this.$api.apiPostKnowledgeEditResourceEntity(this.resourceForm).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.$message.success('保存成功');
				this.$emit('onupdate');
				this.loading = false;
			});
		},
	}
}
</script>

<style lang="scss" scoped>
.basis-cls {
	width: 100%;
	padding: 0 20px;
	box-sizing: border-box;
}
</style>